export default __webpack_public_path__ + "static/media/2.42b17c1b.jpg";